import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class PhoneAuthenticationService {

  private code: number;
  constructor(private http: Http) {

  }
  sendOtp(phoneNumber) {
    var code = Math.floor(100000 + Math.random() * 900000);
    this.code = code;
    return this.http.post("https://api.bulutfon.com/messages", {
      title: "bigadvice",
      receivers: "+90" + phoneNumber,
      content: "bigadvice için doğrulama kodunuz " + code,
      reject_link: false,
      access_token: "9263bfff99e749c491218c4afa4282b5e404766c782a06031bcbdff8d1dc5cfd"
    }).map(res => res.json()).toPromise()
  }
  confirm(code) {
    return this.code == code
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/phone-authentication.service.ts